import React from "react";
import {List, ListInput, Icon, ListItem} from "framework7-react";

interface QuickbetCreateFormProps {
    data?: any
}

export const QuickbetCreateForm: React.FC<QuickbetCreateFormProps> = ({ data }) => {
    return (
        <List strongIos dividersIos insetIos>
            <ListItem><div className='text-align-center'>Create Quickbet Ticket</div></ListItem>
            <ListInput outline label="Status" floatingLabel type="select" placeholder="Status">
                <Icon f7="lock" slot="media" />
                <option value="Enabled">Enabled</option>
                <option value="Disabled">Disabled</option>
            </ListInput>
            <ListInput
                outline
                label="Title"
                floatingLabel
                type="text"
                placeholder="Title"
                clearButton
            >
                <Icon f7="paintbrush" slot="media" />
            </ListInput>
            <ListInput
                outline
                label="Prices"
                floatingLabel
                type="text"
                placeholder="Your Prices"
                clearButton
            >
                <Icon f7="wallet" slot="media" />
            </ListInput>
            <ListInput outline label="Ticket Mode" floatingLabel type="select" placeholder="Ticket Mode">
                <Icon material="toggle_on" slot="media"/>
                <option value="swipe">Swipe View</option>
                <option value="click">Click View</option>
            </ListInput>
            <ListItem>
                Build your QuickBet
            </ListItem>
            <ListInput outline label="Event" floatingLabel type="url" placeholder="Event" clearButton>
                {/*<Icon icon="demo-list-icon" slot="media" />*/}
            </ListInput>
            <ListInput
                outline
                label="Market"
                floatingLabel
                type="tel"
                placeholder="Market"
                clearButton
            >
                {/*<Icon icon="demo-list-icon" slot="media" />*/}
            </ListInput>
        </List>
    )
}